import React, { Component } from 'react'

export default class DownloadFileComponent extends Component {

  constructor(props) {
    super(props);

    this.link =  React.createRef()
    this.state = {
      url: null,
      fileName: ''
    }
  }
  
  download = (blob, filename = 'prueba', extension = '') => {
    const url = window.URL.createObjectURL(blob);
    const fileName = `${filename}.${extension}`;
    this.setState({ fileName, url });
    this.link.current.click();
  }

  render() {
    const {url, fileName} = this.state;
    return (
      <a ref={this.link} href={url} download={fileName} style={{ display: 'none' }} > </a>
    )
  }
}

export { DownloadFileComponent };
